import styled from "styled-components";

const MyAccountAreaHeaderWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  background-color: ${props =>
    props.theme.colors.MyAccountAreaHeaderBackground ?? "#0a0a0a"};
  width: 100%;
  height: 100%;
`;

const AreaHeaderTitle = styled.div`
  margin: 1.5rem auto;
`;

const Title = styled.span`
  font-weight: 700;
  color: ${props => props.theme.colors.textColor};
  font-family: ${props => props.theme.typography.fontFamilyBold};
`;

const AreaHeaderCloseIcon = styled.div`
  position: absolute;
  right: 2rem;
  top: 1.3rem;
  cursor: pointer;

  :hover .svg-wrapper .svg-icon {
    background-color: ${props => props.theme.colors.brandColor};
  }
`;

export {
  MyAccountAreaHeaderWrapper,
  AreaHeaderTitle,
  Title,
  AreaHeaderCloseIcon
};
